import * as React from "react";
import { Redirect, withRouter, RouteComponentProps } from "react-router-dom";
import { UserOrderInformation } from "burde";
import CalendarInfo from "calendar/info";
import {
    getCalendarOrdersForUser,
    getEditableCalendarById,
} from "calendar/service";
import { getCalendarStateFromPrintInfo } from "ui/helper";
import { actionCreators } from "page/calendar/store";
import { actionCreators as uiActionCreators } from "ui/store";
import { NavigationComponents, DefaultSize, DefaultType } from "ui/constants";
import Button from "content/button/button";
import { Spinner } from "common/spinner/spinner";
import { getComponentRoute } from "page/calendar/helper";

type MyPagesProps = {
    Admin_Header_Back: string;
    MyPages_OrderHistory: string;
    MyPages_OrderdCalendars: string;
    userName: string;
} & typeof actionCreators &
    typeof uiActionCreators;

interface MyPagesState {
    orders: Array<UserOrderInformation>;
    openCalendar: boolean;
    openCalendarSize: string;
    openCalendarType: string;
    isLoading: boolean;
}

class MyPages extends React.Component<
    MyPagesProps & RouteComponentProps,
    MyPagesState
> {
    public state: MyPagesState = {
        orders: [],
        openCalendar: false,
        openCalendarSize: DefaultSize,
        openCalendarType: DefaultType,
        isLoading: true,
    };

    private openCalendar = async (printInfoId: number) => {
        const printInfo = await getEditableCalendarById(printInfoId);

        if (printInfo != null && printInfo != undefined) {
            const calendarState = getCalendarStateFromPrintInfo(printInfo);
            this.props.setActiveCalendar(calendarState);

            if (calendarState.calendarSize !== "") {
                this.setState({ openCalendarSize: calendarState.calendarSize });
            }

            if (calendarState.calendarType !== undefined) {
                this.setState({ openCalendarType: calendarState.calendarType });
            }

            this.setState({ openCalendar: true });
        }
    };

    public async componentDidMount() {
        const orders = await getCalendarOrdersForUser();

        this.setState({
            isLoading: false,
            orders,
        });
    }

    public render() {
        const {
            orders,
            openCalendar,
            isLoading,
            openCalendarSize,
            openCalendarType,
        } = this.state;

        const {
            MyPages_OrderHistory,
            MyPages_OrderdCalendars,
            Admin_Header_Back,
        } = this.props;

        if (openCalendar) {
            const route = getComponentRoute(
                NavigationComponents[0].route,
                openCalendarSize,
                openCalendarType,
            );
            return <Redirect to={route} push />;
        }

        return (
            <div className={"container mt-4"}>
                <div className={"row mb-3"}>
                    <div className={"col-8"}>
                        <h1>{MyPages_OrderHistory}</h1>
                    </div>
                    <div className={"col-4 text-right pt-2"}>
                        <Button
                            className={"mr-2"}
                            text={Admin_Header_Back}
                            iconClass={"fas fa-arrow-left"}
                            onClick={this.props.history.goBack}
                        />
                    </div>
                </div>

                <h3>{MyPages_OrderdCalendars}</h3>

                <div className={"row"}>
                    {isLoading && (
                        <div
                            style={{
                                width: "100%",
                                paddingTop: "50px",
                                display: "flex",
                                justifyContent: "center",
                            }}>
                            <Spinner></Spinner>
                        </div>
                    )}

                    {orders.map((c, i) => {
                        return (
                            <CalendarInfo
                                key={i}
                                calendar={c}
                                onClick={() => {
                                    this.props.UpdateActiveNavigationComponent(
                                        NavigationComponents[0],
                                    );
                                    this.openCalendar(c.calendarId);
                                }}
                            />
                        );
                    })}
                </div>
            </div>
        );
    }
}

export default withRouter(MyPages);
